/**
 * @generated SignedSource<<a69ac923aa17d41ea8427c65d2b95fa9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSisenseUserInput = {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  type?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSisenseUserMutation$variables = {
  input: CreateSisenseUserInput;
};
export type CreateSisenseUserMutation$data = {
  readonly createSisenseUser: {
    readonly viewer: {
      readonly id: string;
      readonly sisenseUserId: string | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type CreateSisenseUserMutation = {
  variables: CreateSisenseUserMutation$variables;
  response: CreateSisenseUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSisenseUserPayload",
    "kind": "LinkedField",
    "name": "createSisenseUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sisenseUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSisenseUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSisenseUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9008a87d1c65e76c7b82c59d0bfc92cd",
    "id": null,
    "metadata": {},
    "name": "CreateSisenseUserMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSisenseUserMutation(\n  $input: CreateSisenseUserInput!\n) {\n  createSisenseUser(input: $input) {\n    viewer {\n      id\n      sisenseUserId\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "b33d571581ad1769add7e0a364aa06ed";

export default node;
